import {useEffect, useState} from 'react'
import {useContentfulClient} from './use-contentful-client.hook'
import {useIntl} from 'react-intl'
import {contentfulMediaFormatter} from '../../../utils'

const formatData = ({sys, fields}) => ({
    ...fields,
    sys
})

const formatTopData = (groupLinks) =>
    groupLinks?.map(({fields}) => {
        const links = (fields?.links ?? []).map((item) => formatData(item))
        if (fields?.isDesktop) return {desktop: links}
        return {mobile: links}
    })

export const useGetHeader = () => {
    const {locale} = useIntl()
    const [data, setData] = useState(null)
    const contentfulClient = useContentfulClient()

    useEffect(() => {
        contentfulClient
            .getEntries({
                locale,
                content_type: 'header',
                include: 10
            })
            .then((response) => {
                const items = response?.items ?? []
                const header = items?.at(-1)?.fields ?? null

                if (header) {
                    const {
                        left = [],
                        right = [],
                        top = [],
                        activeMenu = null,
                        announcementBar = null,
                        administratives = [],
                        accountDropdown = []
                    } = header

                    setData({
                        ...header,
                        logo: contentfulMediaFormatter(header?.logo),
                        top: formatTopData(top),
                        left: left.map((item) => formatData(item)),
                        menu: activeMenu?.fields?.list?.fields,
                        announcementBar: {
                            ...announcementBar?.fields,
                            sys: announcementBar?.sys
                        },
                        right: right.map((item) => formatData(item)),
                        account: accountDropdown.map((item) =>
                            formatData(item)
                        ),
                        administratives: administratives.map((item) =>
                            formatData(item)
                        )
                    })
                }
            })
            .catch((error) => console.error('>>>> error', error))
    }, [])

    return {data}
}
